import { render, staticRenderFns } from "./LogoutMenu.vue?vue&type=template&id=31f1d4b1&scoped=true&"
import script from "./LogoutMenu.vue?vue&type=script&lang=js&"
export * from "./LogoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./LogoutMenu.vue?vue&type=style&index=0&id=31f1d4b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1d4b1",
  null
  
)

export default component.exports